export const applicationRouteSeoInfo = {
  title: 'NIAT Application Portal | Login & Registration',
  description:
    'Welcome to the NIAT Application Portal. Manage your NAT test registration, fee payment, and test slot booking.',
  path: '/application'
};
